"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledPoints = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  height: 58px;\n  border-radius: ", ";\n  font-size: 0.75rem;\n\n  background: ", ";\n  color: ", ";\n\n  ", ";\n  ", ";\n\n  ", ";\n"])), function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.colorPrimary;
}, function (p) {
  return p.theme.colorPrimaryText;
}, function (p) {
  return p.isCorrect && "background: ".concat(p.theme.colorSuccess, "; color: ").concat(p.theme.colorSuccessText);
}, function (p) {
  return p.isIncorrect && "background: ".concat(p.theme.colorDanger, "; color: ").concat(p.theme.colorDangerText);
}, function (p) {
  return process.env.REACT_APP_COLOR_PRIMARY_IS_WHITE && "border: 2px solid ".concat(p.theme.colorLightGrey);
});

var StyledPointsNumber = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 0.25rem;\n  font-size: 1.25rem;\n  font-weight: 700;\n  text-align: center;\n"])));

var ContestPicksPoints = function ContestPicksPoints(_ref) {
  var translations = _ref.translations,
      availablePoints = _ref.availablePoints,
      correctAnswerId = _ref.correctAnswerId,
      myAnswerId = _ref.myAnswerId,
      isLocked = _ref.isLocked,
      showIcon = _ref.showIcon;
  var isAnswered = myAnswerId !== -1;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledPoints, {
    isCorrect: isAnswered && isLocked && showIcon && correctAnswerId === myAnswerId,
    isIncorrect: isAnswered && isLocked && showIcon && correctAnswerId !== myAnswerId,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPointsNumber, {
      children: availablePoints
    }), availablePoints === 1 ? translations.point : translations.points]
  });
};

var _default = ContestPicksPoints;
exports.default = _default;